import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

// Globális Teendők dashboard: közelgő határnapok (szín-kódolt) + nyitott tennivalók
// minden ügyből, ügyre kattintva megnyitható.
@Component({
  selector: 'app-caesar-teendok',
  templateUrl: './teendok.component.html',
  styleUrls: ['./teendok.component.scss'],
})
export class TeendokComponent implements OnInit {
  intezmeny = '';
  hatarnapok: any[] = [];
  tennivalok: any[] = [];

  constructor(private http: HttpClient, private data: DataService, private router: Router) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    await this.betolt();
  }

  async betolt() {
    this.hatarnapok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hatarnapok-global/' + this.intezmeny + '?napok=60'));
    this.tennivalok = await firstValueFrom(this.http.get<any[]>('/api/caesar/tennivalok-global/' + this.intezmeny));
  }

  async tennivaloKesz(t: any) {
    await firstValueFrom(this.http.put('/api/caesar/tennivalo/' + t.id, { ...t, kesz: 1 }));
    await this.betolt();
  }

  ugyhoz(id: string) { this.router.navigateByUrl('/caesar/ugy/' + id); }

  szin(datum: string): string {
    if (!datum) return 'medium';
    const d = new Date(datum + 'T00:00:00'); const ma = new Date(); ma.setHours(0, 0, 0, 0);
    const diff = Math.round((d.getTime() - ma.getTime()) / 86400000);
    if (diff < 0) return 'medium'; if (diff === 0) return 'danger'; if (diff === 1) return 'warning'; if (diff <= 4) return 'tertiary'; return 'success';
  }
}
